import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { MarkOrderAsOpenedRequest } from './mark-order-as-opened.request';

@Injectable({ providedIn: 'root' })
export class MarkOrderAsOpenedUseCase extends UseCase<MarkOrderAsOpenedRequest, Observable<void>> {
    private _apiRequestService = inject(ApiRequestService);
    private _orderBackendUrl = inject<string>('ORDER_BACKEND_URL' as never);
    private _markAsOpenedUrl = '/admin/markAsOpened';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: MarkOrderAsOpenedRequest): Observable<void> | void {
        return this._apiRequestService.sendRequest<MarkOrderAsOpenedRequest, void>(
            this._orderBackendUrl,
            request,
            false,
            this._markAsOpenedUrl
        );
    }
}
